import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';

import ResetPasswordPage from '../../../components/pages/auth/resetPassword/ResetPassword.page.jsx';
import { modelPost } from '../../../actions/model.actions';
import {
    ResetPasswordContainerCore,
    mapStateToPropsCore,
    mapDispatchToPropsCore
} from 'pluton-core/lib/containers/pages/auth/ResetPassword.container'


class ResetPasswordContainer extends ResetPasswordContainerCore {
    render() {
        return (
            <ResetPasswordPage
                {...this.props}
            />
        );
    }
}

export default connect(mapStateToPropsCore, mapDispatchToPropsCore(modelPost))(ResetPasswordContainer);



// WEBPACK FOOTER //
// ./app/containers/pages/auth/ResetPassword.container.jsx